<template>
    <div>
        <div v-if="isLoading">
            <spinner></spinner>
        </div>
        <table class="cart-order-confirm" v-else>
            <tr v-for="product in currentProducts">
                <td>
                    <div class="image" style="position: relative;">
                        <img src="/images/thema_stapelkorting_klein.png" alt="stapelkorting" class="stapelkorting" v-if="product.bulk_discount" />
                        <img :src="product.thumbnail" :alt="product.name">
                    </div>
                </td>
                <td>
                    <span v-text="product.name"></span>
                </td>
                <td>
                    <span v-text="product.amount"></span>
                </td>
                <td width="85" class="subtotal">
                    <span>{{ $root.formatPrice(product.linePriceIncl) }}</span>
                </td>
            </tr>
            <tr v-if="deliveryPrice > 0">
                <td>&nbsp;</td>
                <td><span v-text="label('shop.cart.delivery_costs')"></span></td>
                <td colspan="2" class="subtotal"><span>{{ $root.formatPrice(deliveryPrice) }}</span></td>
            </tr>
            <tr v-if="discounts" v-for="discount in this.discounts" class="fontColor">
                <td>&nbsp;</td>
                <td>
                    <span v-text="label('shop.cart.discount_code') + ' ' + discount.code"></span>
                </td>
                <td colspan="2" class="subtotal" v-if="discount.amount"><span>-{{ $root.formatPrice(discount.amount) }}</span></td>
            </tr>
            <tr v-if="this.cart.bulkDiscountAmount > 0" class="fontColor">
                <td>&nbsp;</td>
                <td>
                    <span>{{ label('shop.cart.bulk_discount') }}</span>
                </td>
                <td colspan="2" class="subtotal"><span>-{{ $root.formatPrice(this.cart.bulkDiscountAmount) }}</span></td>
            </tr>
            <tr>
                <td>&nbsp;</td>
                <td><span class="boldFont" v-text="label('shop.cart.total_incl')"></span></td>
                <td colspan="2" class="subtotal boldFont"><span>{{ totalPrice }}</span></td>
            </tr>
        </table>
    </div>
</template>

<script>
import translations from "../mixins/translations";
import Spinner from "./Spinner";
import {EventBus} from "../../events";

export default {
    name: "order-confirm-cart",
    mixins: [translations,],
    components: {
        Spinner,
    },
    props: {
        currency: {
            required: false,
            type: String,
            default: "EUR"
        },
    },
    data: function () {
        return {
            product_counter: 0,
        }
    },
    methods: {},
    computed: {
        isLoading() {
            return !this.cart;
        },
        cart() {
            return this.$store.state.cart.cart;
        },
        currentTotal() {
            if (this.cart) {
                return this.cart.totalPriceIncl;
            }
            return 0;
        },
        totalPrice() {
            if(this.currentTotal === 0){
                $("#payment_methods div.payment_method:not('.payment_method_transfer')").hide();
                $("#payment_method_transfer").attr("checked", true); //set method transfer to check since it's the only option
            } else{
                $("#payment_methods div.payment_method:not('.payment_method_transfer')").show();
            }
            return this.$root.formatPrice(this.currentTotal, this.currency, false);
        },
        currentProducts() {
            return this.$store.state.cart.cartItems;
        },
        deliveryPrice() {
            if (this.cart) {
                return this.cart.deliveryPrice;
            }
            return 0;
        },
        discounts() {
            if(this.cart) {
                return this.cart.discounts;
            }
            return [];
        },
    },
    watch: {},
    mounted() {
        EventBus.$on('updatedCountry', (countryCode) => {
            this.$store.dispatch('cart/updateCountryCode', countryCode);
        });
    },
    created() {
    }

}
</script>
<style>
.stapelkorting{
    top: 0;
    left: 0;
    position: absolute;
    width: 40px;
}
</style>
